import React from 'react';
import ManagerLayout from 'components/Layout/Manager/ManagerLayout';
import { DealersCustomerView } from 'pages/Shared/DealerCustomers';

export const DealersCustomerManagerView: React.FC = () => {
  return (
    <ManagerLayout>
      <DealersCustomerView />
    </ManagerLayout>
  );
};
